import ExternalAccountPage from './components/ExternalAccountPage.vue'

const ExternalAccountArea = {
  ExternalAccountPage,
}

export { ExternalAccountArea }
